import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '../Constants/queryKeys';
import {
  GetDetailedOrganizationRegistrations,
  GetOrganizationById,
  GetOrganizationRegistrations,
  GetOrganizationRegistrationsByOrganizationId,
  GetOrganizations,
  GetReducedOrganizationById,
  GetUserOrganizations,
} from '../helper/apiHelper';

export const useUserOrganizations = (userId: number | undefined) => {
  return useQuery({
    queryKey: [...QUERY_KEYS.ORGANIZATIONS, userId],
    queryFn: () => {
      if (!userId) return null;
      return GetUserOrganizations(userId.toString());
    },
    enabled: !!userId,
  });
};

export const useOrganizations = () => {
  return useQuery({
    queryKey: [...QUERY_KEYS.ORGANIZATIONS],
    queryFn: GetOrganizations,
  });
};

export const useOrganizationById = (orgId: number | string) => {
  return useQuery({
    queryKey: [...QUERY_KEYS.ORGANIZATIONS, orgId],
    queryFn: () => GetOrganizationById(String(orgId)),
    enabled: !!orgId,
  });
};

export const useReducedOrganizationById = (orgId: number | string) => {
  return useQuery({
    queryKey: [...QUERY_KEYS.REDUSED_ORGANIZATIONS, orgId],
    queryFn: () => GetReducedOrganizationById(String(orgId)),
    enabled: !!orgId,
  });
};

export const useUserOrganizationsIds = (userId: number | undefined) => {
  return useQuery({
    queryKey: [...QUERY_KEYS.ORGANIZATIONS, userId],
    queryFn: () => {
      if (!userId) return null;
      return GetUserOrganizations(userId.toString());
    },
    enabled: !!userId,
    select: (organizations) => {
      return organizations?.map((o) => o.id);
    },
  });
};

export const useAllRegistrations = () => {
  return useQuery({
    queryKey: [...QUERY_KEYS.ORGANIZATION_REGISTRATIONS],
    queryFn: () => GetOrganizationRegistrations(),
  });
};

// the registrations of the given study year, the current one if not given
export const useDetailedOrganizationRegistrations = (studyYearId?: number) => {
  return useQuery({
    queryKey: [...QUERY_KEYS.DETAILED_ORGANIZATION_REGISTRATIONS, studyYearId],
    queryFn: () => GetDetailedOrganizationRegistrations(studyYearId),
  });
};

export const useOrganizationsRegistrationsByOrganizationId = (
  organizationId: number | string
) => {
  return useQuery({
    queryKey: [...QUERY_KEYS.ORGANIZATION_REGISTRATIONS, organizationId],
    queryFn: () =>
      GetOrganizationRegistrationsByOrganizationId(String(organizationId)),
  });
};
